import {Component, OnInit} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import { ExternalServerControllerService } from "../../../services/service-controller/external-server-controller.service";
import { ExternalServer } from "../../../models/external-server";
import {MonitoringControllerService} from "../../../services/monitoring-controller/monitoring-controller.service";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "instances",
  templateUrl: "./instances.component.html",
})
export class InstancesComponent extends TranslatedBaseError implements OnInit {

    public instances: any = [];
    public externalServers: ExternalServer[] = [];
    public isLocal: boolean = environment.LOCAL;
    public instanceURL: string = environment.E_REGISTRATIONS_URL;
    public feVersion: string = "1.0.0";
    public beVersion: string = "1.0.0";
    public dsBeVersion: string = "1.0.0";
    public dsFeVersion: string = "1.0.0";
    public gdbVersion: string = "1.0.0";

    constructor(private externalServerService: ExternalServerControllerService,
                private http: HttpClient,
                toastr: ToastrService,
                private monitoringControllerService: MonitoringControllerService,
                public translateService: TranslateService) {
        super(toastr, translateService);
    }

    public ngOnInit() {
        this.loadExternalServers();
        this.getBEVersion();
        this.getDSBeVersion();
        this.getDSFeVersion();
        this.getGDBVersion();
        if (!this.isLocal) {
            this.getFEVersion();
        }
    }

    public loadExternalServers() {
        this.externalServerService.getExternalServers().subscribe(
          (data: ExternalServer[]) => {
            this.instances = data.map((item) => {
                const cleanUrl = item.host.replace(/(^\w+:|^)\/\//, "");
                this.getExternalBEVersion(cleanUrl).subscribe((response) => {
                    if (response && response.app && response.app.version) {
                        item.beVersion = response.app.version;
                    }
                });
                this.getExternalFEVersion(cleanUrl).subscribe((response) => {
                    if (response && response.version) {
                        item.feVersion = response.version;
                    }
                });
                this.getExternalDSBeStatus(cleanUrl).subscribe((response) => {
                    if (response && response.version) {
                        item.dsBeVersion = response.version;
                    }
                });
              this.getExternalDSFeStatus(cleanUrl).subscribe((response) => {
                if (response && response.version) {
                  item.dsFeVersion = response.version;
                }
              });
                this.getExternalGDBStatus("gdbs." + cleanUrl).subscribe((response) => {
                    if (response && response.version) {
                        item.gdbVersion = response.version;
                    }
                });
                return item;
            });
          },
          (error) => this.showErrorMessage(error),
        );
    }

    public getFEVersion() {
        this.monitoringControllerService.getFEVersion().subscribe((data) => {
            if (data && data.version) {
                this.feVersion = data.version;
            }
        });
    }

    public getBEVersion() {
        this.monitoringControllerService.getBEVersion().subscribe((data) => {
            if (data && data.app && data.app.version) {
                this.beVersion = data.app.version;
            }
        });
    }

    public getDSBeVersion() {
        this.monitoringControllerService.getDSBeStatus().subscribe((data) => {
            if (data && data.version) {
                this.dsBeVersion = (data && data.version) || this.dsBeVersion;
            }
        });
    }

    public getDSFeVersion() {
      this.monitoringControllerService.getDSFeStatus().subscribe((data) => {
        if (data && data.version) {
          this.dsFeVersion = (data && data.version) || this.dsFeVersion;
        }
      });
    }

    public getGDBVersion() {
        this.monitoringControllerService.getGDBStatus().subscribe((data) => {
            if (data && data.version) {
                this.gdbVersion = (data && data.version) || this.gdbVersion;
            }
        });
    }

    public getExternalBEVersion(instanceUrl): Observable<any> {
        return this.http.get("https://bpa." + instanceUrl + "/bparest/bpa/v2016/06/info", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
    }

    public getExternalFEVersion(instanceUrl): Observable<any> {
        return this.http.get("https://bpa." + instanceUrl + "/version", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
    }

    public getExternalDSBeStatus(instanceUrl): Observable<any> {
        return this.http.get("https://" + instanceUrl + "/status", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
    }

    public getExternalDSFeStatus(instanceUrl): Observable<any> {
      return this.http.get("https://" + instanceUrl + "/status", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
    }

    public getExternalGDBStatus(instanceUrl): Observable<any> {
        return this.http.get("https://" + instanceUrl + "/api/v1/status", { headers: { ignoreLoadingBar: "" }}) as Observable<any>;
    }

    public publishInstanceSettings(externalServerId: string) {
        this.externalServerService.publishInstanceSettings(externalServerId).subscribe(
            (data: any) => {
                this.responseSuccessful("Settings published successfully!");
            },
            (error) => this.showErrorMessageWithTitle("Failed to publish settings!", error),
        );
    }
}
